function ampSyncCartCounts (count) {
//const headerCartCount = document.querySelector('.nav-item a.current-cart span.cart-count');
const headerCartCount = document.querySelector('hdt-cart-count'); // new cart count selector

if (headerCartCount) {
    headerCartCount.textContent = count;
    
    if (count > 0) {
    headerCartCount.classList.remove('hidden');
    } else {
    headerCartCount.classList.add('hidden');
    }
}
}

function ampHideGiftQuantityButtons () {
// hide quantity selector for gifts
const cartItemPrices = document.querySelectorAll('.amp-cart-drawer .amp-cart__cart-line .amp-cart__cart-line-price, .amp-cart-drawer .amp-cart__cart-line .amp-cart__cart-line-price .amp-cart__cart-line-price--discounted');

cartItemPrices.forEach(price => {
    const priceParent = price.closest('.amp-cart__cart-line-details-bottom');
    
    if (priceParent) {
    const quantitySelector = priceParent.querySelector('.amp-cart__line-quantity-selector');
    
    if (quantitySelector) {
        if (price.textContent === '$0.00') {
        quantitySelector.style.display = 'none';
        priceParent.style.justifyContent = 'flex-end';
        } else {
        quantitySelector.style.display = 'flex';
        priceParent.style.justifyContent = 'space-between';
        }
    }
    }
});
}

function ampCheckFreeGift (cart, cartTarget) {
// automatically remove gift if price falls below threshold
cartTarget.blocks.forEach(block => {
    if (block.type === 'CartRewardsBlock' && block.enabled) {
    block.content.tiers.forEach(tier => {
        if (tier.type === 'FreeGift') {
        const giftThreshold = tier.trigger;
        const giftThresholdConverted = giftThreshold * Shopify.currency.rate;
        const giftHandle = tier.freeGift.handle;
        
        if (cart.total_price/100 < giftThresholdConverted) {
            cart.items.forEach(item => {
            if (item.handle === giftHandle) {
                const variantId = item.variant_id;
                let updates = { [variantId]: 0};
                
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
                })
                .catch((error) => {
                console.error('Error:', error);
                });
            }
            });
        }
        }
    });
    }
});
}

document.addEventListener("click", (e) => {
    const btn = e.target.closest('[name="add"]');
    if (!btn) return;

    setTimeout(() => {
        const modal = document.querySelector('#hdt-quick-add-modal');
        modal?.parentElement?.close?.();
        window.AMP_API?.OPEN_CART?.();
    }, 400);
});

window.AMP_CART_UPDATED = (cart, cartTarget) => {
ampSyncCartCounts(cart.item_count);
ampHideGiftQuantityButtons();
ampCheckFreeGift(cart, cartTarget);
}
